import { PreferencesAction, PreferencesActions } from "./action";
import { SUPPORTED_LANGUAGES } from "../../common/constants";
import arEG from "antd/locale/ar_EG";
import enUS from "antd/locale/en_US";
import { Locale } from "antd/es/locale";

export interface IPreferencesState {
  currentLanguage: SUPPORTED_LANGUAGES;
  direction: "ltr" | "rtl";
  antdLocale: Locale;
  isDarkMode: boolean;
}

export const initialPreferencesState: IPreferencesState = {
  currentLanguage: SUPPORTED_LANGUAGES.EN,
  direction: "ltr",
  antdLocale: enUS,
  isDarkMode: false,
};

export const preferencesReducer = (
  state: IPreferencesState,
  action: PreferencesAction,
): IPreferencesState => {
  switch (action.type) {
    case PreferencesActions.SET_LANGUAGE:
      const direction: "ltr" | "rtl" =
        action.language === SUPPORTED_LANGUAGES.AR ? "rtl" : "ltr";
      const antdLocale =
        action.language === SUPPORTED_LANGUAGES.AR ? arEG : enUS;

      return {
        ...state,
        currentLanguage: action.language,
        direction,
        antdLocale,
      };
    case PreferencesActions.TOGGLE_THEME:
      return {
        ...state,
        isDarkMode: !state.isDarkMode,
      };
    default:
      return {
        ...state,
      };
  }
};
